import { Record } from 'immutable';

const RatePlanCodeRecord = Record({
  eventRatePlanCodeId: null,
  eventId: null,
  chain: null,
  brand: null,
  propertyId: null,
  ratePlanCode: null,
  createdDate: null,
  modifiedDate: null,
  createdBy: null,
  modifiedBy: null,
  canBeDeleted: true
});

export class RatePlanCode extends RatePlanCodeRecord {
  eventRatePlanCodeId: number;
  eventId: number;
  chain: string;
  brand: string;
  propertyId: number;
  ratePlanCode: string;
  createdDate: Date;
  modifiedDate: Date;
  createdBy: string;
  modifiedBy: string;
  canBeDeleted: boolean;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/rate-plan-code.ts